export const emailStepText = {
  head: "Hvert er netfangið þitt?",
  main: "Vinsamlegast skráðu netfangið þitt svo hægt sé að senda nótur, pöntunarstaðfestingar o.fl.",
};
